import React from "react";
import { Table } from "antd";

import styles from "./TabelaRelatorioAluno.module.scss";

const gerarColunas = () => [
    {
        title: "Avaliação",
        dataIndex: "nome",
        key: "nome",
        align: "left",
        width: "60%",
        render: text => <strong>{text}</strong>
    },
    {
        title: "Nota",
        dataIndex: "nota",
        key: "nota",
        align: "center",
        width: "40%",
        render: (text, record) => {
            const notaNumerica = parseFloat(text?.replace(",", "."));
            const isNotaInvalida = !text || isNaN(notaNumerica);
            const isMedia = record.nome === "Média Bimestral" || record.nome === "Média Anual";

            const valor = isNotaInvalida ? "-" : text;

            if (record.nome === "Estado") {
                return <div className={text === "Aprovado" ? "marca-aluno-aprovado" : "marca-aluno-reprovado"}>{text}</div>;
            }

            return <div className={isMedia ? (notaNumerica >= 6 ? "marca-aluno-aprovado" : "marca-aluno-reprovado") : ""}>{valor}</div>;
        }
    }
];

const transformarParaDataSource = (avaliacoes, index) => {
    let statusFinal = "APROVADO";

    const rows = avaliacoes.map(av => {
        const notaNumerica = parseFloat(av.nota?.replace(",", "."));
        const isMedia = av.nome === "Média Bimestral" || av.nome === "Média Anual";
        const isNotaInvalida = av.nota === null || av.nota === "" || isNaN(notaNumerica);

        if ((isNotaInvalida || notaNumerica < 6) && !isMedia) {
            statusFinal = "REPROVADO";
        }

        return {
            key: `${index}-${av.nome}`,
            nome: av.nome,
            nota: av.nota || "-"
        };
    });

    // Adiciona o estado como última linha
    rows.push({
        key: `${index}-estado`,
        nome: "Estado",
        nota: statusFinal === "APROVADO" ? "Aprovado" : "Reprovado"
    });

    return rows;
};

const TabelaRelatorioAlunoMobile = ({ disciplinas }) => {
    if (!disciplinas || disciplinas.length === 0) return null;

    return (
        <div className={styles.listaMobile}>
            {disciplinas.map((disciplina, index) => {
                const colunas = gerarColunas();
                const dataSource = transformarParaDataSource(disciplina.avaliacoes, index);

                return (
                    <div key={index} className="disciplina">
                        <h2 className={styles.tituloDisciplinaMobile}>{disciplina.disciplina}</h2>
                        <Table
                            className={styles.tabela}
                            columns={colunas}
                            dataSource={dataSource}
                            pagination={false}
                            showHeader={false}
                            bordered={false}
                        />
                    </div>
                );
            })}
        </div>
    );
};

export default TabelaRelatorioAlunoMobile;
